import { render, staticRenderFns } from "./ManufacturerTotalOrdersByStatus.vue?vue&type=template&id=534fc1bb&"
import script from "./ManufacturerTotalOrdersByStatus.vue?vue&type=script&lang=js&"
export * from "./ManufacturerTotalOrdersByStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports